var map = {
	"./community-category/index.sync.tsx": 895,
	"./content-curation/HomepageContentCurationContainer.sync.tsx": 896,
	"./header-navigation/index.sync.tsx": 918,
	"./ideation-destination/filters/ProductAreaFilter.sync.tsx": 935,
	"./knowledge-base/index.sync.tsx": 938,
	"./product-updates-destination/ProductUpdatesOverview.sync.tsx": 955,
	"./site-wide/index.sync.tsx": 975,
	"./topic-banner/TopicBanner.sync.tsx": 1016,
	"./widget-custom-html/index.sync.tsx": 1029,
	"./widget-featured-topics/index.sync.tsx": 401,
	"./widget-header/index.sync.tsx": 1041
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1399;